import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Checkbox } from '@mui/material';
import { Column } from 'primereact/column';
import moment from 'moment';
import {
  StyledBoxTable,
  styledColumnHeaderCheckbox
} from '../../../components/layout/main/mainStyles';
import { LoadingRowsComponent } from '../../../components/commons/LoadingRows/LoadingRows';

import { SerialNumberTemplateTemplateProps } from './serialNumberTemplateProps';

export const SerialNumberTemplate = ({
  isLoading,
  isSuccess,
  allSerialNumber,
  selectedItems,
  setSelectedItems
}: SerialNumberTemplateTemplateProps) => {
  const getHeaderCheckbox = () => {
    return (
      <Checkbox
        className="p-checkbox"
        style={{
          visibility: selectedItems.length ? 'visible' : 'hidden'
        }}
        checked={
          (allSerialNumber && selectedItems && selectedItems.length > 0) ??
          false
        }
        onChange={() => {
          setSelectedItems([]);
        }}
      />
    );
  };
  const getFormattedDate = (rowData: { manufacturingDate: string }) => {
    if (rowData.manufacturingDate) {
      return moment(rowData.manufacturingDate).format('MM/DD/YYYY HH:MM');
    }
    return '';
  };
  return (
    <StyledBoxTable>
      {isLoading && <LoadingRowsComponent />}
      {isSuccess && allSerialNumber && (
        <DataTable
          selectionMode="multiple"
          metaKeySelection
          selection={selectedItems}
          value={allSerialNumber ?? []}
          size="small"
          scrollable
          scrollHeight="flex"
          onSelectionChange={(e) => setSelectedItems(e.value)}
          paginator={allSerialNumber && allSerialNumber.length >= 50}
          selectionPageOnly
          rows={50}
          rowsPerPageOptions={[5, 10, 20, 50]}
          tableStyle={{ padding: 0, margin: 0, fontSize: '14px' }}
          className="mt-3"
          rowHover
        >
          <Column
            selectionMode="multiple"
            headerStyle={styledColumnHeaderCheckbox}
            header={getHeaderCheckbox}
            frozen
          />
          <Column field="partNumber" header="Part Number" sortable />
          <Column
            field="startSerialNumber"
            header="Start Serial Number"
            sortable
          />
          <Column field="endSerialNumber" header="End Serial Number" sortable />
          <Column
            field="manufacturingDate"
            header="Manufacturing Date"
            sortable
            body={getFormattedDate}
          />
        </DataTable>
      )}
    </StyledBoxTable>
  );
};
